import { render, staticRenderFns } from "./DescAttachmentDel.vue?vue&type=template&id=8ee34896&scoped=true&"
import script from "./DescAttachmentDel.vue?vue&type=script&lang=js&"
export * from "./DescAttachmentDel.vue?vue&type=script&lang=js&"
import style0 from "./DescAttachmentDel.vue?vue&type=style&index=0&id=8ee34896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee34896",
  null
  
)

export default component.exports